<template>
  <ul class="gy-navigation">
    <li class="gy-navigation-item" v-for="item in nav" :key="item.path">
      <span @click="goHref(item)" v-if="item.path.includes('http')">
        {{ item.name }}
      </span>
      <span v-else @click="goPath(item)">{{ item.name }}</span>
    </li>
  </ul>
</template>

<script>
import Cookies from "js-cookie";
export default {
  props: {
    nav: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      path: ["/consultative", "/cooperation", "/medicineInfo"],
    };
  },
  methods: {
    goHref(item) {
      if (Cookies.get("token")) {
        if (item.name === "实训课堂") {
          window.open(item.path, "_blank", "height=812,width=375,resizable=no");
        } else {
          window.open(item.path);
        }
      } else {
        this.$message.error({
          message: "请先登录！",
          type: "error",
          duration: 1000,
        });
        this.$router.push({
          path: "/login",
        });
      }
    },
    goPath(item) {
      if(item.path=='/chineseMedicine'){
        this.$router.push({
          path: `${item.path}`,
        });
      } else if (Cookies.get("token") || this.path.includes(item.path)) {
        this.$router.push({
          path: `${item.path}`,
        });
      } else {
        this.$message.error({
          message: "请先登录！",
          type: "error",
          duration: 1000,
        });
        this.$router.push({
          path: "/login",
        });
      }
    },
  },
};
</script>

<style lang="less">
.gy-navigation {
  display: flex;
  list-style: none;
  &-item {
    padding: 0 20px;
    span {
      font-size: 20px;
      color: #ffffff;
      text-decoration: none;
      cursor: pointer;
    }
  }
}
</style>
